import type { BadgeProps } from '@fluentui/react-components';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import { ERegistrationStatus, ERegistrationValidity } from './types';

export const REGISTRATIONS_QUERY_KEY = 'registrations';
export const REGISTRATIONS_ENDPOINT = '/registrations';
export const REGISTRATIONS_PATH = '/registrations';
export const REGISTRATIONS_NAV_VALUE = 'registrations-dashboard';
export const REGISTRATIONS_TABLE_ID = 'registrations-table';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/registrations/configs/registrations.config.ts
// and the list DTO in backend/src/registrations/dtos/registrations.dto.ts.
export const MAX_REGISTRATION_METADATA_TEXT_LENGTH = 2000;
export const MAX_REGISTRATION_SEARCH_LENGTH = 200;
export const MAX_REGISTRATION_PAGE_SIZE = 200;
export const DEFAULT_REGISTRATION_PAGE_SIZE = 25;

export const REGISTRATION_STATUS_OPTIONS: { value: ERegistrationStatus; label: string; color: BadgeProps['color'] }[] =
  [
    { value: ERegistrationStatus.PLANNED, label: 'Planned', color: 'informative' },
    { value: ERegistrationStatus.IN_PROGRESS, label: 'In progress', color: 'brand' },
    { value: ERegistrationStatus.ACTIVE, label: 'Active', color: 'success' },
    { value: ERegistrationStatus.SUSPENDED, label: 'Suspended', color: 'warning' },
    { value: ERegistrationStatus.EXPIRED, label: 'Expired', color: 'danger' },
    { value: ERegistrationStatus.WITHDRAWN, label: 'Withdrawn', color: 'subtle' },
  ];

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/registrations/configs/registrations.config.ts
export const REGISTRATION_EXPIRATION_WINDOW_DAYS = 60;

export const REGISTRATION_VALIDITY_OPTIONS: { value: ERegistrationValidity; label: string }[] = [
  { value: ERegistrationValidity.EXPIRED, label: 'Validity date passed' },
  { value: ERegistrationValidity.NEXT_60_DAYS, label: `Expiring within ${REGISTRATION_EXPIRATION_WINDOW_DAYS} days` },
];

export const PAST_VALIDITY_DATE_MESSAGE = `This ${TERMINOLOGY.registrationSingle.lower} is past its validity date.`;
